import styled, { css } from 'styled-components';
import { mediaMixin } from '@zillow/constellation';

export const Container = styled.div`
  width: 100%;
  min-height: 300px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;

  ${mediaMixin(
    'xl',
    css`
      flex-direction: row;
    `,
  )};
`;

export const Slide = styled.div`
  width: 100%;
  min-height: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: lightgray;
`;

export const TextContainer = styled.div`
  flex: 1;
  max-width: 615px;
`;

export const ImageContainer = styled.div`
  position: relative;
  width: 440px;
  height: 280px;
  display: flex;
  align-items: center;

  ${({ imgPosition }: { imgPosition: 'left' | 'right' }) => {
    return {
      marginLeft: imgPosition === 'right' ? '40px' : '',
      marginRight: imgPosition === 'left' ? '40px' : '',
      justifyContent: imgPosition === 'left' ? 'flex-start' : 'flex-end',
    };
  }}
`;

export const ImageContainerMweb = styled.div`
  position: relative;
  width: 100%;
  height: 300px;
  display: flex;
  justify-content: center;
  align-items: center;

  ${({ usePadding }: { usePadding: boolean }) => usePadding && 'padding: 24px;'}
`;

export const Background = styled.div`
  width: 390px;
  height: 270px;
  background-size: cover;

  ${({ src }: { src: string }) =>
    src && {
      backgroundImage: `url(${src})`,
    }}
`;

export const OverlayContainer = styled.div`
  position: absolute;
  top: 0;
  width: 256px;

  ${({ imgPosition }: { imgPosition: 'left' | 'right' }) => (imgPosition === 'left' ? 'right: 0' : 'left: 0')}
`;

export const OverlayImage = styled.img`
  max-width: 100%;
  vertical-align: middle;
`;
